import CheckBoxIcon from '@propertypal/shared/src/resources/icons/checklist/checkbox.svg';
import WilsonNesbittLogo from '@propertypal/shared/src/resources/logos/wilson-nesbitt-logo.jpg';
import React from 'react';
import { useTheme } from 'styled-components';
import { SubHeading, Text } from '../typography';
import {
  Logo,
  Container,
  ContentContainer,
  ContentWrapper,
  List,
  CalculateButton,
} from './LegalFeesCalculatorLite.style.pn';

const wilsonNesbittExternalUrl =
  'https://wilson-nesbitt.com/property/residential-property/legal-fees-quotation/?entry=%7b%22Source%22:%22PropertyNews%22%7d';

interface LegalFeesCalculatorLiteProps {
  onCalculateClick: () => void;
}

const LegalFeesCalculatorLite: React.FC<LegalFeesCalculatorLiteProps> = ({ onCalculateClick }) => {
  const theme = useTheme();
  return (
    <Container data-testid="legal-fees-calculator">
      <ContentContainer>
        <ContentWrapper>
          <SubHeading fontSize={20} fontWeight="600" mb={8}>
            Legal Fees Calculator
          </SubHeading>
          <Text fontSize={20} mb={8}>
            <span>Making an offer on a property?</span>{' '}
            <span style={{ display: 'block' }}>You will need a solicitor.</span>
          </Text>
          <Text mb={16} color={theme.backgroundMid}>
            Budget now for legal costs by using our fees calculator.
          </Text>
        </ContentWrapper>
        <ContentWrapper>
          <Text mb={8} fontWeight="600">
            Solicitor Checklist
          </Text>
          <List>
            <li>
              <CheckBoxIcon /> On the panels of all the mortgage lenders?
            </li>
            <li>
              <CheckBoxIcon /> Specialists in Conveyancing?
            </li>
            <li>
              <CheckBoxIcon /> Online Case Tracking available?
            </li>
            <li>
              <CheckBoxIcon /> Award-winning Client Service?
            </li>
          </List>
        </ContentWrapper>
      </ContentContainer>
      <ContentContainer alignCenter>
        <ContentWrapper>
          <a
            href={wilsonNesbittExternalUrl}
            rel="noreferrer"
            target="_blank"
            onClick={onCalculateClick}
            data-testid="calculate-legal-fees"
          >
            <CalculateButton>Calculate Legal Fees</CalculateButton>
          </a>
        </ContentWrapper>
        <ContentWrapper>
          <a
            href={wilsonNesbittExternalUrl}
            rel="noreferrer"
            target="_blank"
            onClick={onCalculateClick}
            data-testid="legal-fees-logo"
          >
            <Logo src={WilsonNesbittLogo.src} alt="wilson nesbitt logo" />
          </a>
        </ContentWrapper>
      </ContentContainer>
    </Container>
  );
};

export default LegalFeesCalculatorLite;
